import { DataFormats } from '@skylab-shared/constants';
import { ConsoleLogger, Query, QueryHandler } from '@skylab-shared/core';
import * as axios from 'axios';
import { format } from 'fecha';
import { NipValidator } from '../../common/validators/nip-validator';
import { WHITE_LIST_API } from './white-list-api';

export interface SearchCLientBankAccountsQueryResponse {
    bankAccountsWhiteList: string[];
    requestId: string;
}

export class SearchClientBankAccountsQuery extends Query<SearchCLientBankAccountsQueryResponse> {
    public constructor(public nip: string) {
        super();
    }
}

export class SearchClientBankAccountsQueryHandlerBase implements QueryHandler<SearchClientBankAccountsQuery, SearchCLientBankAccountsQueryResponse> {
    private logger = new ConsoleLogger(this.constructor.name);

    public async handleAsync(query: SearchClientBankAccountsQuery): Promise<SearchCLientBankAccountsQueryResponse> {
        try {
            if (NipValidator.isValid(query.nip)) {
                const response = await axios.default.get<{result: { requestId: string }}>(`${WHITE_LIST_API}/search/nip/${query.nip}`, {
                    params: {
                        date: this.getWhiteListRequestValidDate(),
                    },
                });
                if (response.status === 200) {
                    return { bankAccountsWhiteList: this.getBankAccounts(response.data), requestId: response.data?.result?.requestId || '' };
                }
            }
            return { bankAccountsWhiteList: [] , requestId: '' };
        } catch (err) {
            this.logger.error(err);
            return { bankAccountsWhiteList: [] , requestId: '' };
        }
    }

    private getBankAccounts(data: any): string[] {
        return data?.result?.subject?.accountNumbers || [];
    }

    private getWhiteListRequestValidDate(): string {
        const date = new Date();
        return format(date, DataFormats.date.webApi);
    }
}

// example return data:
// {
//     "result" : {
//       "subject" : {
//         "authorizedClerks" : [ ],
//         "regon" : "regon",
//         "restorationDate" : "2019-02-21",
//         "workingAddress" : "ul/ Prosta 49 00-838 Warszawa",
//         "hasVirtualAccounts" : true,
//         "statusVat" : "Zwolniony",
//         "krs" : "0000636771",
//         "restorationBasis" : "Ustawa o podatku od towarÃ³w i usÅ‚ug art. 96",
//         "accountNumbers" : [ "90249000050247256316596736", "90249000050247256316596736" ],
//         "registrationDenialBasis" : "Ustawa o podatku od towarÃ³w i usÅ‚ug art. 96",
//         "nip" : "1111111111",
//         "removalDate" : "2019-02-21",
//         "partners" : [ ],
//         "name" : "ABC Jan Nowak",
//         "registrationLegalDate" : "2018-02-21",
//         "removalBasis" : "Ustawa o podatku od towarÃ³w i usÅ‚ug Art. 97",
//         "pesel" : "22222222222",
//         "representatives" : [ {
//           "firstName" : "Jan",
//           "lastName" : "Nowak",
//           "nip" : "1111111111",
//           "companyName" : "Nazwa firmy"
//         }, {
//           "firstName" : "Jan",
//           "lastName" : "Nowak",
//           "nip" : "1111111111",
//           "companyName" : "Nazwa firmy"
//         } ],
//         "residenceAddress" : "ul/ Chmielna 85/87 00-805 Warszawa",
//         "registrationDenialDate" : "2019-02-21"
//       },
//       "requestId" : "d2n10-84df1a1"
//     }
//   }
